/* OVERLI product gallery: swipe + snap, dots (mobile), thumbs (desktop), tap-to-zoom. RTL safe. */
(function () {
  'use strict';

  function centerDelta(container, el) {
    var c = container.getBoundingClientRect();
    var e = el.getBoundingClientRect();
    return (e.left + e.width / 2) - (c.left + c.width / 2);
  }

  function initSlider(root) {
    if (root.dataset.ovSliderBound === '1') return;
    root.dataset.ovSliderBound = '1';

    var track = root.querySelector('[data-ov-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ov-slide]'));
    if (slides.length < 2) return;

    var gallery = root.closest('.ov-gallery') || document;
    var thumbsWrap = gallery.querySelector('[data-ov-thumbs]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-ov-thumb]'));
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-ov-dot]'));
    var prevBtn = root.querySelector('[data-ov-prev]');
    var nextBtn = root.querySelector('[data-ov-next]');
    var counter = root.querySelector('[data-ov-current]');
    var index = 0;

    function nearestIndex() {
      var best = 0, min = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var d = Math.abs(centerDelta(track, slides[i]));
        if (d < min) { min = d; best = i; }
      }
      return best;
    }

    function mark(list, i) {
      for (var n = 0; n < list.length; n++) {
        if (n === i) list[n].classList.add('active');
        else list[n].classList.remove('active');
      }
    }

    function paint(i) {
      index = i;
      mark(thumbs, i);
      mark(dots, i);
      if (counter) counter.textContent = String(i + 1);
      if (prevBtn) prevBtn.disabled = (i === 0);
      if (nextBtn) nextBtn.disabled = (i === slides.length - 1);
      if (thumbsWrap && thumbs[i] && thumbsWrap.offsetParent !== null) {
        var d = centerDelta(thumbsWrap, thumbs[i]);
        if (Math.abs(d) > 6) thumbsWrap.scrollBy({ left: d, behavior: 'smooth' });
      }
    }

    function go(i) {
      if (i < 0) i = 0;
      if (i > slides.length - 1) i = slides.length - 1;
      var d = centerDelta(track, slides[i]);
      if (Math.abs(d) > 1) track.scrollBy({ left: d, behavior: 'smooth' });
      paint(i);
    }

    var settle;
    track.addEventListener('scroll', function () {
      clearTimeout(settle);
      settle = setTimeout(function () { paint(nearestIndex()); }, 90);
    }, { passive: true });

    if (prevBtn) prevBtn.addEventListener('click', function () { go(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(index + 1); });

    function bindJump(list) {
      for (var k = 0; k < list.length; k++) {
        (function (n) {
          list[n].addEventListener('click', function (e) { e.preventDefault(); go(n); });
        })(k);
      }
    }
    bindJump(thumbs);
    bindJump(dots);

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index - 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(index + 1); }
    });

    paint(0);
  }

  function initZoom() {
    var overlay = document.querySelector('[data-ov-zoom]');
    if (!overlay || overlay.dataset.ovBound === '1') return;
    overlay.dataset.ovBound = '1';

    var big = overlay.querySelector('[data-ov-zoom-img]');
    var scrollY = 0;

    function open(src, alt) {
      if (!big) return;
      big.setAttribute('src', src);
      big.setAttribute('alt', alt || '');
      overlay.hidden = false;
      scrollY = window.scrollY;
      document.body.style.overflow = 'hidden';
    }
    function close() {
      overlay.hidden = true;
      document.body.style.overflow = '';
      if (big) big.removeAttribute('src');
    }

    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) close();
    });

    // Open on a genuine tap only, never at the end of a swipe.
    var imgs = document.querySelectorAll('[data-ov-slide] img');
    for (var i = 0; i < imgs.length; i++) {
      (function (img) {
        var sx = 0, sy = 0, moved = false;
        img.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; moved = false; });
        img.addEventListener('pointermove', function (e) {
          if (Math.abs(e.clientX - sx) > 8 || Math.abs(e.clientY - sy) > 8) moved = true;
        });
        img.addEventListener('click', function (e) {
          if (moved) { e.preventDefault(); return; }
          var full = img.getAttribute('data-full') || img.currentSrc || img.src;
          open(full, img.getAttribute('alt'));
        });
      })(imgs[i]);
    }
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-ov-slider]');
    for (var i = 0; i < nodes.length; i++) initSlider(nodes[i]);
    initZoom();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
